import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=ebb81d76&scoped=true&"
import script from "./CookieLaw.vue?vue&type=script&lang=js&"
export * from "./CookieLaw.vue?vue&type=script&lang=js&"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=ebb81d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb81d76",
  null
  
)

export default component.exports